/*
 * ----------------------------------------
 *
 * Based on https://github.com/mozilla/localForage/blob/master/src/drivers/websql.js
 *
 */
var localforageSsatbDriver = {
    DRIVER_NAME : 'localForage-SsatbDriver'
};
(function () {
    'use strict';

    // Promises!
    var Promise = (typeof module !== 'undefined' && module.exports) ?
        require('promise') : this.Promise;

    var globalObject = this;
    var serializer = null;


    var ModuleType = {
        DEFINE: 1,
        EXPORT: 2,
        WINDOW: 3
    };

    // Attaching to window (i.e. no module loader) is the assumed,
    // simple default.
    var moduleType = ModuleType.WINDOW;

    // Find out what kind of module setup we have; if none, we'll just attach
    // localForage to the main window.
    if (typeof module !== 'undefined' && module.exports) {
        moduleType = ModuleType.EXPORT;
    } else if (typeof define === 'function' && define.amd) {
        moduleType = ModuleType.DEFINE;
    }

    function _initStorage(options) {
        var self = this;
        var apiInfo = null;
        if (options) {
            self._apiInfo = options.apiInfo;
        }
        return Promise.resolve();
    }

    function appendServiceResponseHeaders(obj, jqXHR) {
        var headers = null;
        if (obj != null)
            if (jqXHR != null) {
                var headersStr = jqXHR.getAllResponseHeaders();
                var headersArray = headersStr.split("\n");
                var headers = {};
                for (var i in headersArray) {
                    if (headersArray.hasOwnProperty(i)) {
                        var header = headersArray[i];
                        var kvs = header.split(":");
                        var key = kvs[0];
                        if (key) {
                            key = key.trim();
                            if (key.length != 0) {
                                var val = kvs[1];
                                if (val)
                                    val = val.trim();
                                headers[key] = val;
                            }
                        }
                    }
                }
            }
            else
                console.warn("jqXHR is null. Headers not populated");
        if (headers != null)
            obj.responseHeaders = headers;
        return obj;
    }

    function iterate(iterator, callback) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
                var apiInfo = getDefaultApiDetails(self._apiInfo);

                $.ajax({
                    method: apiInfo.iterate.verb ? apiInfo.iterate.verb : "GET",
                    url: apiInfo.Url + apiInfo.iterate.url,
                    headers: apiInfo.Headers,
                    global: false,
                    cache: false,
                    dataType: "json",
                    contentType: 'application/json; charset=utf-8',
                }).done(function (items) {
                    var length = items.length;
                    for (var i = 0; i < length; i++) {
                        var item = items[i];
                        item = iterator(item, item[apiInfo.iterate.keyProperty],
                                   i + 1);
                        if (item !== void (0)) {
                            resolve(item);
                            return;
                        }
                    }
                    resolve();
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    reject(getServerError(apiInfo, jqXHR, textStatus, errorThrown));
                });

            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }

    function getItem(key, callback) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
                var apiDetails = getApiDetails(key);
                var apiInfo = self._apiInfo[apiDetails.serviceName];

                $.ajax({
                    method: apiDetails.verb,
                    url: apiInfo.Url + apiDetails.url,
                    dataType: "json",
                    global: false,
                    cache: false,
                    contentType: 'application/json; charset=utf-8',
                    headers: apiInfo.Headers
                }).done(function (obj, responseStatus, jqXHR) {
                    resolve(appendServiceResponseHeaders(obj, jqXHR));
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        if (apiDetails.ignore404 && angular.isDefined(jqXHR.status) && jqXHR.status === 404)
                        resolve(appendServiceResponseHeaders(null, jqXHR));
                    else
                        reject(getServerError(apiDetails, jqXHR, textStatus, errorThrown));
                });

            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }
    function setItem(key, value, callback) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
                var apiDetails = getApiDetails(key);
                var apiInfo = self._apiInfo[apiDetails.serviceName];

                $.ajax({
                    method: apiDetails.verb,
                    url: apiInfo.Url + apiDetails.url,
                    dataType: "json",
                    global: false,
                    cache: false,
                    contentType: 'application/json; charset=utf-8',
                    headers: apiInfo.Headers,
                    data: JSON.stringify(value)
                }).done(function (response, responseStatus, jqXHR) {
                    value.response = response;
                    resolve(appendServiceResponseHeaders(value, jqXHR));
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    reject(getServerError(apiDetails, jqXHR, textStatus, errorThrown));
                });

            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }

    function removeItem(key, callback) {
        var self = this;

        // Cast the key to a string, as that's all we can set as a key.
        if (typeof key !== 'string') {
            window.console.warn(key +
                ' used as a key, but it is not a string.');
            key = String(key);
        }
        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
                var apiDetails = getApiDetails(key);
                var apiInfo = self._apiInfo[apiDetails.serviceName];
                $.ajax({
                    method: apiDetails.verb,
                    url: apiInfo.Url + apiDetails.url,
                    global: false,
                    cache: false,
                    headers: apiInfo.Headers
                }).done(function () {
                    resolve()
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    reject(getServerError(apiDetails, jqXHR, textStatus, errorThrown));
                });
            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }

    function clear(callback) {
        var self = this;

        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }

    function length(callback) {
        var self = this;

        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }

    function key(n, callback) {
        var self = this;

        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
            }).catch(reject);
        });

        executeCallback(promise, callback);
        return promise;
    }

    function keys(callback) {
        var self = this;

        var promise = new Promise(function (resolve, reject) {
            self.ready().then(function () {
            }).catch(reject);
        });
        executeCallback(promise, callback);
        return promise;
    }

    function executeCallback(promise, callback) {
        if (callback) {
            promise.then(function (result) {
                callback(null, result);
            }, function (error) {
                callback(error);
            });
        }
    }

    function getApiDetails(key) {
        var api = key.split("|");
        return {
            serviceName: api[0],
            verb: api[1],
            url: api[2],
            ignore404: api.length > 3 ? api[3] : false
        };
    }
    function getDefaultApiDetails(apiHashmap) {
        var defaultKey = null;
        for (var firstKey in apiHashmap) {
            defaultKey = firstKey;
            break;
        }
        if (defaultKey == null)
            return null;
        return apiHashmap[defaultKey];
    }

    function getServerError(apiDetails, jqXHR, textStatus, errorThrown) {
        return {
            serviceName: apiDetails.serviceName,
            method: apiDetails.verb,
            status: jqXHR.status,
            url: apiDetails.url,
            statusText: textStatus,
            errorThrown: errorThrown,
            data: jqXHR.responseJSON
        };
    }


    var driver = {
        _driver: localforageSsatbDriver.DRIVER_NAME,
        _initStorage: _initStorage,
        _support: true,
        iterate: iterate,
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        length: length,
        key: key,
        keys: keys
    };
    if (moduleType === ModuleType.DEFINE) {
        define(localforageSsatbDriver.DRIVER_NAME, function () {
            return driver;
        });
    } else if (moduleType === ModuleType.EXPORT) {
        module.exports = driver;
    } else {
        this[localforageSsatbDriver.DRIVER_NAME] = driver;
    }

    localforage.defineDriver(driver);

}).call(window);
